exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.muted[data-v-0de4a011]{color:#999;}\n.mono[data-v-0de4a011]{font-family:Consolas,monospace;}\n", ""]);

// exports
